export const IsUrlFMModule = (window.location.origin === "https://web-tst.fmmodule.nl" || window.location.origin === "https://web.fmmodule.nl");
export const IsUrlCarpetLine = (window.location.origin === "https://portal.carpetline.nl" || window.location.origin === "https://portal.carpetline.nl" || window.location.origin === "http://localhost:3000");

export const productInfo = {
    methods: {
      isFMModule: function() {

        const isRouteFMModule = this.$route.matched.some(({ path }) => path === '/fmmodule');      
        return isRouteFMModule || IsUrlFMModule;
      }, 
      isCarpetline: function() {
        const isRouteCarpetLine = this.$route.matched.some(({ path }) => path === '/carpetline');      
        return isRouteCarpetLine || IsUrlCarpetLine;
      },            
      productShortName: function() {
        if (this.isFMModule()) {
          return "FM"
        }
        if (this.isCarpetline()) {
          return "carpet"
        }        
        else {
            return "Be"
        }
      },
      productShortNameAlt: function() {
        if (this.isCarpetline()) {
          return ""
        }        
        else {
            return ""
        }
      },      
      productLongName: function() {
        if (this.isFMModule()) {
          return "Module"
        }
        if (this.isCarpetline()) {
          return "line"
        }        
        else {
            return "Simple"
        }
      },
    }
  }